var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('LoadingOverlay',{scopedSlots:_vm._u([{key:"heading",fn:function(){return [_vm._v(" Authenticating, wait a second... ")]},proxy:true}],null,false,463638437)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }